import { Icon, IconProps } from '@clarion/ClarionIcon';
import * as React from 'react';
import { cx } from '../util';
import { H4 } from './Typography';

export type NonIdealStateProps = Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> & {
  action?: React.JSX.Element;
  description?: React.ReactNode;
  icon?: IconProps['icon'];
  iconSize?: number;
  title?: React.ReactNode;
  TitleElement?: React.ComponentType<React.HTMLAttributes<HTMLHeadingElement>>;
};

export function ClarionNonIdealState({
  action,
  className,
  iconSize = 48,
  icon,
  description,
  title,
  TitleElement = H4,
  ...htmlProps
}: NonIdealStateProps) {
  return (
    <div
      className={cx(
        'flex flex-col items-center justify-center text-center w-full h-full gap-5 *:max-w-[400px]',
        className,
      )}
      {...htmlProps}
    >
      {icon && <Icon icon={icon} size={iconSize} className="text-gray-400" />}
      <div className="dark:opacity-80">
        {title && <TitleElement>{title}</TitleElement>}
        {description && <p>{description}</p>}
      </div>
      {action}
    </div>
  );
}
